// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.SideMenuHelp{
    max-width: 100%;
    max-height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/SideMenuHelp.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["\n.SideMenuHelp{\n    max-width: 100%;\n    max-height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
